<!--
 * @Author: LHB
 * @Date: 2022-06-08 22:04:13
 * @LastEditTime: 2022-07-23 09:58:42
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\ChangeWx\index.vue
 * ---
-->

<template>
  <div class="wrap">
    <!-- 第一步-start -->
    <div class="content" v-if="!isSuccess">
      <div class="box-input box-phone">
        <div>
          <p class="login-title">更换微信</p>
          <p class="login-sub-title">
            更换课程微信，原微信号将解绑所有的课程权益，学习记录也会清空哦，请核对无误后更换。
          </p>
          <p class="change-tips">您的上课微信：</p>
          <div class="info-box">
            <img class="avatar" :src="user.avatar" alt="" />
            <span class="name">{{ user.nickname }}</span>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <van-button class="loginBtn" @click="changeWx">更换</van-button>
      </div>
    </div>
    <!-- 第一步-end -->
    <!-- 第二步-start -->
    <div class="content content2" v-else>
      <div class="top">
        <img
          class="icon-success"
          src="../../assets/images/success.png"
          alt=""
        />
        <div class="title1">解绑成功</div>
        <div class="title2">
          将课程平台链接转发至新微信号， 使用购课手机号登录
        </div>
      </div>
      <!-- 成功步骤1-start -->
      <div class="bottom bottom1">
        <div class="left step-item">
          <div class="step-title">
            <img
              class="step-title-icon"
              src="../../assets/images/invite_title_photo1@2x.png"
              alt=""
            />
          </div>
          <p class="step-info">
            已生成您专属的所有课程权益链接，为保障您课程权益的安全，此链接只有
            <span class="tips-waring">2个小时的有效期</span
            >，点下方按钮即可复制。
          </p>
          <van-button
            class="copy-btn"
            @click="copyclick"
            :disabled="isCopyed"
            v-clipboard:success="copySuccess"
            v-clipboard:error="copyError"
            v-clipboard:copy="copyWxLink"
            >{{ copyBtnTitle }}</van-button
          >
        </div>
      </div>
      <!-- 成功步骤2-start -->
      <div class="bottom bottom2">
        <div class="left step-item">
          <div class="step-title">
            <img
              class="step-title-icon"
              src="../../assets/images/invite_title_photo2@2x.png"
              alt=""
            />
          </div>
          <p class="step-info">
            关闭本页面，将复制的链接发送给新的微信号。
            在微信对话输入框里长按即可粘贴专属链接。
          </p>
          <img
            class="step-bottom-icon"
            src="../../assets/images/photo2@2x.png"
            alt=""
          />
        </div>
      </div>
      <!-- 成功步骤3-start -->
      <div class="bottom3">
        <div class="left step-item">
          <div class="step-title3">
            <img
              class="step-title-icon3"
              src="../../assets/images/invite_title_photo3@2x.png"
              alt=""
            />
          </div>
          <p class="step-info">
            新的微信号，收到链接后，点击链接按步骤操作即可绑定成功。
          </p>
          <div class="bottom3-content">
            <div class="left step-item">
              <img
                class="step-icon"
                src="../../assets/images/step_link@2x.png"
                alt=""
              />
              <div class="step-des">在新微信打开链接</div>
            </div>
            <div class="center">
              <img
                class="setp-arrow"
                src="../../assets/images/step_line@2x.png"
                alt=""
              />
            </div>
            <div class="right step-item">
              <img
                class="step-icon"
                src="../../assets/images/step_wechat@2x.png"
                alt=""
              />
              <div class="step-des">按操作绑定微信即可</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 第二步-end -->

    <!-- 组件 -->
    <confirmModal
      v-if="isShowLogout"
      :isShowpop="isShowLogout"
      :mainTitle="mainTitle"
      confirmText="确定更换"
      :cutomClass="cutomClass"
      @cancle="isShowLogout = !isShowLogout"
      @confirm="changeConfirm"
    ></confirmModal>
  </div>
</template>
<script>
import group from '../common/group'
import utils from '../../utils/index.js'
import tools from '../common/tools.js'
import wx_tools from '../common/wx_tools.js'
import urls from '../../utils/urls'

import confirmModal from '../../components/ConfirmModal'

export default {
  name: 'changewx',
  components: { confirmModal },
  data() {
    return {
      isSuccess: false,
      loginLoading: false,
      loadingText: '正在修改',
      isShowLogout: false,
      user: '',
      token: '',
      tokenKey: 'tokenKey',
      isCopyed: false,
      copyBtnTitle: '点我复制专属链接',
      mainTitle:
        '更换微信将解绑您所有课程权益，学习记录也会清空，确认解绑微信吗？',
      cutomClass: {
        fontSize: '15px',
        textAlign: 'left'
      },
      copyWxLink: '',
      mainKeFuUrl:
        'https://work.weixin.qq.com/kfid/kfc7d5301c836e053ab?enc_scene=ENC3QTNZ7Rwc9EQ8M5WrnVEQqEKTCwzPjr5UJoegdoirVD3oEZqobbRv4h4uQM6aFF8aV'
    }
  },
  mounted() {
    document.title = '雪梨英语'
    this.token = localStorage.getItem(this.tokenKey)
    console.log('channgeWx', this.token)
    this.getUser()
    this.initShare()
  },
  watch: {},
  methods: {
    getUser() {
      const params = { token: this.token }
      group.userGet
        .call(this, params)
        .then((res) => {
          console.log('changerwx信息', res)
          if (res.data.success) {
            this.user = res.data.data
            console.log('changerwx信息2', this.user)
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    changeWx() {
      this.isShowLogout = true
    },
    changeConfirm() {
      const params = { token: this.token }
      group.createBind
        .call(this, params)
        .then((res) => {
          console.log('create-info', res)
          if (res.data.success) {
            this.isSuccess = true
            this.isShowLogout = false

            let tempJumpLink = utils.urls.bindUrl
            if (tempJumpLink.indexOf('?') > -1) {
              tempJumpLink += '&bindcode=' + res.data.data
            } else {
              tempJumpLink += '?bindcode=' + res.data.data
            }

            this.copyWxLink = tempJumpLink
            console.log('拷贝链接===', tempJumpLink)
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    copyclick() {
      console.log('拷贝')
    },
    copySuccess() {
      console.log('复制成功', this.copyWxLink)
      this.$toast('已复制')
      this.isCopyed = true
      this.copyBtnTitle = '复制成功'
    },
    copyError() {
      this.$toast('当前浏览器不支持复制，请手动拷贝链接')
    },

    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
<style scoped></style>
